import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {useContextMenu} from "../../../../../Hooks";
import makeStyles from "@material-ui/core/styles/makeStyles";
const useStyles = makeStyles(() => ({
    optContainer: {
        position: 'absolute',
        visibility: 'visible',
        top: 3,
        left: -2
    }
}));
const OptionsMenu = (props) => {
    const {addGroup, removeGroup, path, valueIndex, creatable, removable} = props;
    const classes = useStyles();
    const {ContextMenu, onOpen, isOpen} = useContextMenu({
        addBefore: addGroup,
        addAfter: addGroup,
        remove: removeGroup,
        editRecord: null,
    });

    if (!creatable && !removable) return <></>;
    const disabledOptions = {
        remove: !removable,
        after: !creatable,
        before: !creatable
    };

    function onOpenContext(e) {
        onOpen(e, `${path}.${valueIndex}`, path, valueIndex, disabledOptions)
    }

    return (
        <div className={classes.optContainer} style={{visibility: isOpen && 'visible'}}>
            <IconButton size={"small"} onClick={onOpenContext}>
                <Icon fontSize={"small"}>
                    more_vert
                </Icon>
            </IconButton>
            <ContextMenu/>
        </div>
    )
};
export default OptionsMenu
OptionsMenu.propTypes = {
    addGroup: PropTypes.func,
    removeGroup: PropTypes.func,
    path: PropTypes.string,
    valueIndex: PropTypes.number,
    creatable: PropTypes.bool,
    removable: PropTypes.bool
}